// frontend/src/components/AppLayout/AppLayout.js
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar'; // Importa el Sidebar que ya creamos
import './AppLayout.css';

export default function AppLayout() {
  const location = useLocation();
  const noSidebar = location.pathname.startsWith('/app/superadmin');
  return (
    <div className={`app-layout-container ${noSidebar ? 'no-sidebar' : ''}`}>
      {!noSidebar && <Sidebar />}
      <main className="app-main-content">
        <Outlet />
      </main>
    </div>
  );
}